import { GET_ORDERS } from "./orders.constants";

export const getOrders = (payload = {}, callback) => ({type: GET_ORDERS, payload, callback})